export default __webpack_public_path__ + "static/media/No smoking Icon - Selected.4987cc2a.svg";